import React from "react";
import "./AnimatedCoffeeMug.scss";
const AnimatedCoffeeMug = () => {
  return (
    <div>
      <div className="full-window">
        <div className="main-container">
          <div className="coffee-mug">
            <div className="coffee-container">
              <div className="coffee"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnimatedCoffeeMug;
